import { GovernanceSettings } from './../../../../core/services/governance-settings.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

/* export interface Image {
  url: string;
  name: string;
  size: number;
  status: string;
  file_id: string;
  isPublic: boolean;
  directory: string;
  extension: string;
  file_type: string;
  mime_type: string;
} */

export interface Section {
  image: any;
  en_title: string;
  te_title: string;
  en_content: string;
  te_content: string;
}

@Component({
  selector: 'app-public-places',
  templateUrl: './public-places.component.html',
  styleUrls: ['./public-places.component.scss']
})
export class PublicPlacesComponent implements OnInit {
/* --------------------------------- Fields --------------------------------- */
  sections = [
    {
      id: "mosques",
      title: "Mosques"
    }, {
      id: "parks",
      title: "Parks"
    },
     {
      id: "temples",
      title: "Temples"
    }, {
      id: "churches",
      title: "Churches"
    }
  ];

  publicPlaces!:GovernanceSettings;
  selectedSection!: Section;
  lang!:  string;

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    slidesPerGroup: 4,
    speed: 2000,
    spaceBetween: 15,
    // autoplay: {
    //   delay: 6000,
    //   disableOnInteraction: false,
    // },
    keyboard: true,
    loop: false,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    autoplay: false,
    slidesOffsetAfter: 0,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    navigation: {
      nextEl: '.initiatives-button-next',
      prevEl: '.initiatives-button-prev',
    },
    breakpoints: {
      240: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      600: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      991: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 4
      },
    },
  }
/* ------------------------------- Constructor ------------------------------ */
selectedSectionId!: string;
  constructor(private route: ActivatedRoute) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
    this.publicPlaces = this.route.snapshot.data.publicPlaces;
    this.route.paramMap.subscribe(paramMap=> {
      const id = paramMap.get('id');
      if(id){
        this.selectedSectionId = id;
        this.selectedSection = this.publicPlaces[id];
      }
    });
    this.route.queryParamMap.subscribe(queryParamMap => {
      this.lang = queryParamMap.get('lang') ?? 'en';
    });
  }
}

